<template>
    <div id="nav" class="navbar">
        <div class="navbar-brand">
          <a role="button" v-on:click="mobileMenuActive = !mobileMenuActive" v-bind:class="{'is-active': mobileMenuActive}" class="navbar-burger" aria-label="menu" aria-expanded="false">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
      <div class="navbar-menu" v-bind:class="{'is-active': mobileMenuActive}">
        <div class="navbar-item" v-on:click="navigate"><router-link to="/">Home</router-link></div>
        <div class="navbar-item" v-on:click="navigate"><router-link to="/about">About</router-link></div>
        <div class="navbar-item" v-on:click="navigate" v-if="!isLoggedIn"><router-link to="/login">Login</router-link></div>
        <div class="navbar-item" v-on:click="navigate" v-if="isLoggedIn"><router-link to="/profile" >Profil</router-link></div>
        <div class="navbar-item" v-on:click="navigate" v-if="isLoggedIn"> <router-link v-on:click.native="logout" to="/#logout">Logout</router-link></div>
      </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            mobileMenuActive: false
        }
    },
    computed : {
        isLoggedIn : function(){ return this.$store.getters.isAuthenticated}
    },
    methods : {
        logout: function () {
            this.$store.dispatch('logout')
            .then(() => {
                this.$router.push('/login')
            })
        },
        navigate: function() {
            this.mobileMenuActive = false;
        }
    }
    
}
</script>

<style scoped>
    .navbar-item a {
        width: 100%;
        display: inline-block;
    }
</style>